import { render, staticRenderFns } from "./ConsolidationUnionTableAdmin.vue?vue&type=template&id=656507dd&scoped=true"
import script from "./ConsolidationUnionTableAdmin.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656507dd",
  null
  
)

export default component.exports